import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const deleteEntityMaster = (id: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.entityDelete),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      id,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { deleteEntityMaster }
